import chroma from "chroma-js";
import globals from "../partials/global-variables";
import { pageTransitions } from "../partials/transition";
import stylesConfig from "../styles.config";

const questionHeadingFontSize = {
  $lg: stylesConfig.typography.fontSize(1.3),
  $xs: stylesConfig.typography.fontSize(1.1),
};
const questionHeadingFontColor = stylesConfig.colors.primaryFontColor;

export default {
  container: {
    extend: pageTransitions,
    "& .page-title, & .page-submit-success-headline": {
      color: questionHeadingFontColor,
      textAlign: "center",
      width: "100%",
      fontWeight: 400,
      fontSize: questionHeadingFontSize.$lg,
      margin: [0, 0, "36px"],
      [`@media (${globals.breakpoints.$xs})`]: {
        fontSize: questionHeadingFontSize.$xs,
      },
    },
    "& .page-submit-success-subtitle": {
      textAlign: "center",
      width: "100%",
    },
    "& .page-submit-success-message-wrapper": {
      marginTop: "15px",
      marginBottom: "50px",
    },
    "& .questions-wrapper.multi-answer": {
      backgroundColor: "transparent",
      padding: "26px 15px 35px",
      position: "relative",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      margin: "auto",
      marginBottom: "25px",
      flexFlow: "row wrap",
      [`@media (${globals.breakpoints.$xs})`]: {
        width: `${globals.fixedpoints.$mobileform} !important`,
      },
      [`@media (${globals.breakpoints.$minXs})`]: {
        width: `${globals.fixedpoints.$tabletform} !important`,
      },
      [`@media (${globals.breakpoints.$minSm})`]: {
        width: `${globals.fixedpoints.$desktopform} !important`,
      },
      "&:before": {
        content: "' '",
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        backgroundColor: `${chroma(globals.colors.contrastLight).alpha(0.6)}`,
      },
      "& .text-question-wrapper, & .file-question": {
        [`@media (${globals.breakpoints.$xs})`]: {
          width: `${globals.fixedpoints.$mobilelead} !important`,
        },
        [`@media (${globals.breakpoints.$minXs})`]: {
          width: "50% !important",
        },
      },
      "& > div": {
        position: "relative",
        width: "50%",
        marginBottom: "10px",
        marginTop: "10px",
        padding: "0 20px",
        [`@media (${globals.breakpoints.$xs})`]: {
          width: `${globals.fixedpoints.$mobilelead} !important`,
          padding: 0,
        },
        [`@media (${globals.breakpoints.$minXs})`]: {
          width: `${globals.fixedpoints.$tabletlead} !important`,
          maxWidth: `${globals.fixedpoints.$desktopform} !important`,
        },
        [`@media (${globals.breakpoints.$minSm})`]: {
          width: `${globals.fixedpoints.$desktoplead} !important`,
        },
      },
    },
    "& .questions-wrapper.multi-answer.page-submit-in-progress div": {
      visibility: "hidden",
    },
    "& .questions-wrapper.multi-answer.page-submit-in-progress": {
      backgroundColor: "transparent",
      backgroundImage: globals.loaderGif,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
  },
};
